
import { defineComponent, PropType } from "vue";

interface Data {
   name: string;
   plain?: boolean;
   round?: boolean;
   circle?: boolean;
   loading?: boolean;
   disabled?: boolean;
   type?: string;
   icon?: string;
   style?: any;
}

export default defineComponent({
   props: {
      /**
       * @param {Array} data 按钮组信息
       */
      data: {
         type: Array as PropType<Data[]>,
         default: (): Data[] => [],
      },

      /**
       * @param {String} loading 加载状态
       */
      loading: {
         type: Boolean,
         default: false,
      },
   },
});
